<div class="header-container"
     *ngIf="withHeader">
  <div class="title-container">
    <div class="title">Notifications</div>
  </div>
</div>
<div class="notifications-container adloop-scrollbar"
     appClickStopPropagation
     appScrollTopBottom
     *ngIf="loaded$ | async">
  <app-notification-section [site]="site$ | async"></app-notification-section>
  <app-notification-section [site]="site"
                            *ngFor="let site of sites$ | async"></app-notification-section>
  <div class="no-notifications-container"
       *ngIf="!(notifications$ | async).length">
    {{ 'notifications.no_notification' | translate }}
  </div>
</div>
